import { useQueries, UseQueryResult } from '@tanstack/react-query'
import { useSelector } from 'react-redux'
import { Formula } from '../types/Formula'
import { getFormulaOptions } from './getFormulaOptions'
import { appLanguageSelector } from '../../../redux/app/selectors'

export const useMultipleCompanyFormulas = (companyIds?: string[]): UseQueryResult<Formula[], Error>[] => {
  const validCompanyIds = [...new Set(companyIds?.filter(Boolean) || [])]
  const lng = useSelector(appLanguageSelector)
  const queries = validCompanyIds.map(companyId => getFormulaOptions(companyId, lng))
  return useQueries({ queries })
}
